import { Injectable } from '@angular/core'
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router'
import { Store } from '@ngrx/store'
import { combineLatest, Observable, of } from 'rxjs'
import { map, take, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { authSelectors } from 'src/app/core/auth/auth.selectors'
import { environment } from 'src/environments/environment'
import { AppRoutesNS } from '../../app-routes.namespace'
import { MemberStatus } from '../member/member'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { resolveMobileAppRedirect } from 'src/app/shared/utils/mobile-app-redirect'

@Injectable({
  providedIn: 'root'
})
export class PagesAuthRedirectGuard implements CanActivate {
  private authRedirectPages = new Set([
    AppRoutesNS.Pages.LOGIN,
    AppRoutesNS.Pages.FORGOT_PASSWORD,
    AppRoutesNS.Pages.REGISTER
  ])

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private configurationService: ConfigurationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const targetUrl = state.url

    if (!this.authRedirectPages.has(targetUrl as AppRoutesNS.Pages)) {
      return of(true)
    }

    return combineLatest([
      this.store.select(authSelectors.selectMember),
      this.configurationService.isMobileApp$
    ]).pipe(
      take(1),
      map(([member, isMobileApp]) => {
        // Only redirect if member exists AND is authenticated (not a guest)
        if (member && member.status !== MemberStatus.GUEST) {
          const redirectUrl = isMobileApp
            ? resolveMobileAppRedirect()
            : environment.moduleConfigs?.authModule
                ?.afterLoginSuccessRedirect ||
              AppRoutesNS.Upcoming.UPCOMING_BOOKINGS
          return this.router.parseUrl(redirectUrl)
        }
        return true
      })
    )
  }
}
